var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.173,
    height: 20,
    viewBox: "0 0 17.173 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-refresh-1152932",
    transform: "translate(-179.26 -77.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13533",
    "data-name": "Path 13533",
    d: "M195.932,85.95a8.412,8.412,0,0,0-4.7-5.093,8.808,8.808,0,0,0-6.93.082l1.127-3.1-1.057-.392L182.543,82.4l4.746,2.314.5-1.02-3.32-1.6a7.824,7.824,0,0,1,6.307-.2,7.3,7.3,0,0,1,4.086,4.4,7.331,7.331,0,0,1-3.96,9.317,7.3,7.3,0,0,1-6.008.113,7.447,7.447,0,0,1-4.509-6.437l-1.127.082a8.528,8.528,0,0,0,5.183,7.389h0a8.413,8.413,0,0,0,6.925-.127,8.426,8.426,0,0,0,4.566-10.687Z",
    transform: "translate(0)",
    fill: "#3b4452"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset__icon.01765181afda276c4807fee6aeb08293.svg";
export { ForwardRef as ReactComponent };